<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:穿梭框应用
-->
<template>
  <h-dialog
    v-model="formVisible"
    title="特征选择"
    width="720px"
    height="67vh"
    zIndex="2000"
    @close="closeDialog"
  >
    <div class="selectFeature">
      <div
        v-for="(item, index) in dataOption"
        :key="index"
        class="selectFeatureRow"
      >
        <span>{{ item.name }}</span>
        <div v-for="(it, ind) in item.label" :key="ind">
          <el-button
            class="btn"
            :class="{ activeBtn: it.code == featureParams[item.type] }"
            @click="btnClick(item, index, it)"
            >{{ it.value }}</el-button
          >
        </div>
        <template v-if="item.select">
          <el-select
            v-model="item.selectValue"
            placeholder="其他选择"
            style="width: 100px"
          >
            <el-option
              v-for="it in moreColorList"
              @click="btnClick(item, index, it)"
              :key="it.type"
              :label="it.value"
              :value="it.code"
            >
            </el-option>
          </el-select>
        </template>
        <template v-if="item.name == '机动车类型：'">
          <el-select
            v-model="item.selectValue"
            placeholder="其他选择"
            style="width: 100px"
          >
            <el-option
              v-for="it in moreVehicleList"
              @click="btnClick(item, index, it)"
              :key="it.type"
              :label="it.value"
              :value="it.code"
            >
            </el-option>
          </el-select>
        </template>
        <template v-if="item.name == '车牌号码'">
          <HCarPlateNoSelect
            v-model:plateInfo="item.platenum"
            label=""
            ref="plateNoRef"
          />
        </template>
      </div>
    </div>
    <template #button>
      <h-button type="primary" @click="emitCheckList">确定</h-button>
      <h-button @click="closeDialog">取消</h-button>
    </template>
  </h-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  computed,
  nextTick,
} from "vue";
import { getDict } from "@/api/constant";
import { getMenutree } from "@/api/system/region.js";
import util from "@util/js";
export default defineComponent({
  name: "selectFeature",
  components: {},
  props: {
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
    // 展示弹窗
    type: {
      type: String,
      default: "face",
    },
  },
  emits: ["selectFeature", "update:visible"],
  setup(props, context) {
    let colorList = ref([]);
    let moreColorList = ref([]);
    let sexList = ref([]); //性别
    let ageGroupList = ref([]); //年龄段
    let hairLenList = ref([]); //头发长度
    let coatGrainList = ref([]); //上衣纹理
    let coatStyleList = ref([]); //上衣款式
    let pantsStyleList = ref([]); //下衣款式
    let otherFeatureList = ref([]); //其他人物特征
    let vehicleList = ref([]); //机动车类型
    let moreVehicleList = ref([]); //下拉款中机动车类型
    let isCarryPeopleList = ref([]); //是否带人
    let nonVehicleTypeList = ref([]); //非机动车类型
    const data = reactive({
      formVisible: false,
      selectData: [
        {
          name: "性别：",
          label: sexList,
          type: "sexCode",
        },
        { name: "年龄段：", label: ageGroupList, type: "ageGroup" },
        {
          name: "背包：",
          label: [
            { value: "背包", code: "1" },
            { value: "未背包", code: "-1" },
          ],
          type: "bagStyle",
        },
        {
          name: "头发长度：",
          label: hairLenList,
          type: "hairLen",
        },
        {
          name: "上衣颜色：",
          label: colorList,
          select: true,
          selectValue: "请选择",
          type: "coatColor",
        },
        {
          name: "上衣纹理：",
          label: coatGrainList,
          type: "coatGrain",
        },
        {
          name: "上衣款式：",
          label: coatStyleList,
          type: "coatStyle",
        },
        {
          name: "下衣颜色：",
          label: colorList,
          select: true,
          selectValue: "请选择",
          type: "trousersColor",
        },
        { name: "下衣款式：", label: pantsStyleList, type: "pantsStyle" },
        {
          name: "其他人物特征：",
          label: otherFeatureList,
          type: "otherFeature",
        },
        {
          name: "帽子：",
          label: [
            { value: "带帽", code: "1" },
            { value: "未带帽", code: "-1" },
          ],
          type: "cap",
        },
        {
          name: "机动车类型：",
          label: vehicleList,
          selectValue: "请选择",
          type: "vehicleClass",
        },
        {
          name: "机动车颜色：",
          label: colorList,
          select: true,
          selectValue: "请选择",
          type: "vehicleColor",
        },
        { name: "载人：", label: isCarryPeopleList, type: "carryPeople" },
        {
          name: "非机动车类型：",
          label: nonVehicleTypeList,
          type: "nonVehicleType",
        },
        {
          name: "非机动车颜色：",
          label: colorList,
          select: true,
          selectValue: "请选择",
          type: "nonVehicleColor",
        },
        // { name: "车牌号码：", value: ["带帽", "未带帽"],type:'gender' },
      ],
      selectCarData: [
        {
          name: "机动车类型：",
          label: vehicleList,
          selectValue: "请选择",
          type: "vehicleClass",
        },
        {
          name: "机动车颜色：",
          label: colorList,
          select: true,
          selectValue: "请选择",
          type: "vehicleColor",
        },

        {
          name: "车牌号码",
          platenum: {},
          type: "plateNo",
        },
      ],
      selectColor: [],
      featureParams: {}, //存按钮选中的属性
      featureParamsValue: [],
    });
    const refData = toRefs(data);
    //使用wache监听不报红
    watchEffect(() => {
      data.formVisible = props.visible;
      // dataOption;
      nextTick(() => {
        data.featureParams = {};
      });
    });
    const dataOption = computed(() => {
      if (props.type == "face") {
        return data.selectData;
      } else if (props.type == "car") {
        return data.selectCarData;
      }
    });
    const emitCheckList = () => {
      if (props.type == "car") {
        data.featureParams.platenum = {
          colorCode: data.selectCarData[2].platenum.plateColor,
          colorName: data.selectCarData[2].platenum.plateColorName,
          localCode: data.selectCarData[2].platenum.ownershipCode,
          localName: data.selectCarData[2].platenum.ownership,
          localNumber: data.selectCarData[2].platenum.plateNo,
        };
      }
      context.emit("selectFeature", data.featureParams);
      context.emit("update:visible", false);
    };
    const closeDialog = () => {
      context.emit("update:visible", false);
    };
    const btnClick = (item, index, it) => {
      if (JSON.stringify(data.featureParams) == "{}") {
        data.featureParams[item.type] = it.code;
      } else {
        //对象中 有无 item.type属性 无  直接添加。如果有该属性判断是替换属性值还是删除该属性
        if (data.featureParams[item.type]) {
          if (data.featureParams[item.type] == it.code) {
            delete data.featureParams[item.type];
            return;
          } else {
            data.featureParams[item.type] = it.code;
            //下拉框中属性值和前面按钮中互斥
            if (colorList.value.some((item) => item.code == it.code)) {
              item.selectValue = "请选择";
            }
            if (vehicleList.value.some((el) => el.code === it.code)) {
              item.selectValue = "请选择";
            }
          }
        } else {
          data.featureParams[item.type] = it.code;
        }
      }
      data.featureParamsValue = Object.values(data.featureParams);
    };
    // 获取数据字典
    const queryMenuType = async () => {
      const resColor = await getDict("color");
      const resSex = await getDict("sex");
      const resAgeGroup = await getDict("age_group");
      const resHairLen = await getDict("hair_len");
      const resCoatGrain = await getDict("coat_grain");
      const resCoatStyle = await getDict("coat_style");
      const resPantsStyle = await getDict("pants_style");
      const resOtherFeature = await getDict("other_feature");
      const resVehicleClass = await getDict("vehicle_class");
      const resIsCarryPeople = await getDict("is_carry_people");
      const resNonVehicleType = await getDict("non_vehicle_type");

      moreColorList.value = resColor.dict;
      sexList.value = resSex.dict;
      ageGroupList.value = resAgeGroup.dict;
      hairLenList.value = resHairLen.dict;
      coatGrainList.value = resCoatGrain.dict;
      coatStyleList.value = resCoatStyle.dict;
      pantsStyleList.value = resPantsStyle.dict;
      otherFeatureList.value = resOtherFeature.dict;
      moreVehicleList.value = resVehicleClass.dict;
      isCarryPeopleList.value = resIsCarryPeople.dict;
      nonVehicleTypeList.value = resNonVehicleType.dict;

      colorList.value = resColor.dict.filter((item) => {
        if (item.value === "黑" || item.value == "白" || item.value == "灰") {
          return item;
        }
      });
      vehicleList.value = resVehicleClass.dict.filter((item, index) => {
        return index < 3;
      });
    };
    queryMenuType();
    return {
      ...refData,
      emitCheckList,
      btnClick,
      dataOption,
      closeDialog,
      colorList,
      moreColorList,
      sexList,
      ageGroupList,
      hairLenList,
      coatGrainList,
      coatStyleList,
      pantsStyleList,
      otherFeatureList,
      vehicleList,
      moreVehicleList,
      isCarryPeopleList,
      nonVehicleTypeList,
    };
  },
});
</script>
<style lang="scss" scoped>
.selectFeature {
  height: 50vh;
  width: 90%;
  margin: 50px auto 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .selectFeatureRow {
    width: 95%;
    display: flex;
    // align-items: center;
    margin: 5px;
    height: 50px;
    span {
      width: 100px;
    }
    .btn {
      margin-right: 5px;
    }
    .activeBtn {
      background-color: var(--el-color-primary);
      color: #fff;
    }
  }
}
</style>
